"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _dalError = require("./dal-error");

Object.keys(_dalError).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _dalError[key];
    }
  });
});

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var DAL =
/*#__PURE__*/
function () {
  function DAL() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        transport = _ref.transport,
        endpoints = _ref.endpoints,
        _ref$dedupe = _ref.dedupe,
        dedupe = _ref$dedupe === void 0 ? false : _ref$dedupe,
        _ref$key = _ref.key,
        key = _ref$key === void 0 ? this.defaultRequestKey : _ref$key;

    (0, _classCallCheck2["default"])(this, DAL);

    if (!transport) {
      throw new Error('No transport provided');
    }

    if (!endpoints || !Object.keys(endpoints).length) {
      throw new Error('No endpoints provided');
    }

    this._transport = transport;
    this._requests = new Map();
    this._options = {
      dedupe: dedupe,
      key: key
    };
    this.incorporateEndpoints(endpoints);
    this.exposeClientMethods({
      setToken: 'useToken',
      setHeader: 'setHeader'
    });
  }

  (0, _createClass2["default"])(DAL, [{
    key: "isUsingUnauthenticatedToken",
    value: function isUsingUnauthenticatedToken() {
      return this.unauthenticatedToken === this._transport.getToken();
    }
  }, {
    key: "setUnauthenticatedToken",
    value: function setUnauthenticatedToken(token) {
      this.unauthenticatedToken = token;
    }
  }, {
    key: "useUnauthenticatedToken",
    value: function useUnauthenticatedToken() {
      if (!this.unauthenticatedToken) {
        throw new Error('No unauthenticated token provided');
      }

      this.useToken(this.unauthenticatedToken);
    }
  }, {
    key: "exposeClientMethods",
    value: function exposeClientMethods(methods) {
      var _this = this;

      Object.keys(methods).forEach(function (clientMethodName) {
        if (_this._transport[clientMethodName]) {
          _this[methods[clientMethodName]] = _this._transport[clientMethodName].bind(_this._transport);
        }
      });
    }
  }, {
    key: "onError",
    value: function onError(error) {
      if (!this.errorHandler) {
        throw error;
      } else {
        return this.errorHandler(error);
      }
    }
  }, {
    key: "checkForErrors",
    value: function checkForErrors(response) {
      if (response && Object.keys(response).indexOf('success') !== -1 && !response.success) {
        throw new Error('response failed');
      } else {
        return response;
      }
    }
  }, {
    key: "substituteUrl",
    value: function substituteUrl(pattern, args) {
      var argIdx = 0;
      return {
        substitutedUrl: pattern.replace(/\$\d+/g, function () {
          argIdx += 1;
          return args[argIdx - 1];
        }),
        params: args[argIdx],
        overrides: args[argIdx + 1]
      };
    }
  }, {
    key: "defaultRequestKey",
    value: function defaultRequestKey(_ref2) {
      var url = _ref2.url,
          params = _ref2.params;
      return [url, JSON.stringify(params)].join(':');
    }
  }, {
    key: "mergeOptions",
    value: function mergeOptions(endpointOptions, requestOptions) {
      return _objectSpread({}, this._options, {}, endpointOptions, {}, requestOptions);
    }
  }, {
    key: "doRequest",
    value: function doRequest(method, objPath, urlPattern, options) {
      var _this2 = this;

      for (var _len = arguments.length, args = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
        args[_key - 4] = arguments[_key];
      }

      var _this$substituteUrl = this.substituteUrl(urlPattern, args),
          params = _this$substituteUrl.params,
          overrides = _this$substituteUrl.overrides,
          substitutedUrl = _this$substituteUrl.substitutedUrl;

      var requestOptions = this.mergeOptions(options, overrides);
      var publicArgs = {
        url: substitutedUrl,
        params: params,
        headers: this._transport.headers,
        method: method
      };
      var requestKey = requestOptions.key(publicArgs);
      var canDedupe = typeof requestOptions.dedupe === 'function' ? requestOptions.dedupe(publicArgs) : requestOptions.dedupe;

      if (canDedupe && this._requests.has(requestKey)) {
        return this._requests.get(requestKey);
      }

      var request = function request() {
        return _this2._transport[method.toLowerCase()](substitutedUrl, params, requestOptions, objPath).then(_this2.checkForErrors.bind(_this2))["catch"](_this2.onError.bind(_this2));
      };

      var requestPromise = request()["finally"](function () {
        return _this2._requests["delete"](requestKey);
      });

      this._requests.set(requestKey, requestPromise);

      return requestPromise;
    }
  }, {
    key: "doDebugRequest",
    value: function doDebugRequest(method, objPath, urlPattern, options) {
      var _console;

      for (var _len2 = arguments.length, args = new Array(_len2 > 4 ? _len2 - 4 : 0), _key2 = 4; _key2 < _len2; _key2++) {
        args[_key2 - 4] = arguments[_key2];
      }

      (_console = console).log.apply(_console, ["Making ".concat(method, " call to ").concat(urlPattern, " with")].concat(args)); // eslint-disable-line no-console


      return this.doRequest.apply(this, [method, objPath, urlPattern, options].concat(args)).then(function (response) {
        console.log('SUCCESS', JSON.stringify(response, null, '  ')); // eslint-disable-line no-console

        return response;
      })["catch"](function (err) {
        console.log('ERROR', err); // eslint-disable-line no-console

        throw err;
      });
    }
  }, {
    key: "incorporateEndpoints",
    value: function incorporateEndpoints(endpoints) {
      var _this3 = this;

      Object.entries(endpoints).forEach(function (_ref3) {
        var _ref4 = (0, _slicedToArray2["default"])(_ref3, 2),
            objPath = _ref4[0],
            endpointConfig = _ref4[1];

        var _endpointConfig = (0, _slicedToArray2["default"])(endpointConfig, 3),
            method = _endpointConfig[0],
            urlPattern = _endpointConfig[1],
            _endpointConfig$ = _endpointConfig[2],
            options = _endpointConfig$ === void 0 ? {} : _endpointConfig$;

        var parts = objPath.split('.');
        var on = parts.slice(0, parts.length - 1).reduce(function (memo, key) {
          if (!memo[key]) {
            memo[key] = {};
          }

          return memo[key];
        }, _this3);
        on[parts[parts.length - 1]] = _this3.doRequest.bind(_this3, method, objPath, urlPattern, options);
        on["_".concat(parts[parts.length - 1])] = _this3.doDebugRequest.bind(_this3, method, objPath, urlPattern, options);
      });
    }
  }]);
  return DAL;
}();

exports["default"] = DAL;